import { useEffect, useLayoutEffect, useRef, useState } from 'react';

export const VIEWER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const PURPLE = '#922A8C';

export const fmtTime = (iso) => new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

export const fmtClock = (hhmm) => {
  if (!hhmm) return '—';
  const [h, m] = hhmm.split(':').map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
};

export const pctColor = (p) => (p >= 70 ? '#22B04B' : p >= 40 ? '#F5B400' : '#EF3A5D');

export const usePaged = (items, size, ms) => {
  const [page, setPage] = useState(0);
  const pages = Math.max(1, Math.ceil(items.length / size));
  useEffect(() => {
    if (pages <= 1) { setPage(0); return undefined; }
    const t = setInterval(() => setPage((p) => (p + 1) % pages), ms);
    return () => clearInterval(t);
  }, [pages, ms]);
  const current = Math.min(page, pages - 1);
  return { slice: items.slice(current * size, current * size + size), page: current, pages };
};

// Pages hold as many rows as fit in the ref'd container (measured from the first row).
export const useFitPaged = (items, ms) => {
  const ref = useRef(null);
  const [size, setSize] = useState(3);
  const paged = usePaged(items, size, ms);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const calc = () => {
      const row = el.firstElementChild;
      if (row && row.offsetHeight) setSize(Math.max(1, Math.floor(el.clientHeight / row.offsetHeight)));
    };
    calc();
    const ro = new ResizeObserver(calc);
    ro.observe(el);
    return () => ro.disconnect();
  }, [items.length, paged.page]);
  return { ref, ...paged };
};

export const PageDots = ({ page, pages, testid }) => (pages > 1 ? (
  <div className="flex gap-1.5 justify-center pt-1" data-testid={testid}>
    {Array.from({ length: pages }).map((_, i) => (
      <span key={i} className="h-2 rounded-full" style={{ width: i === page ? 22 : 8, background: i === page ? PURPLE : '#e3d6e6', transition: 'width .3s' }} />
    ))}
  </div>
) : null);
